"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    orders: {
      actions: {
        addNewOrder: 'Pridať objednávku',
        all: 'Všetky objednávky'
      },
      listPage: {
        title: 'Objednávky',
        table: {
          filter: {
            number: 'Číslo'
          },
          columns: {
            contact: 'Kontakt',
            dateOfOrder: 'Dátum objednania',
            number: 'Číslo',
            offer: 'Ponuka',
            opportunity: 'Dopyt',
            owner: 'Vlastník',
            state: 'Stav',
            total: 'Celkom',
            totalUserCurrency: 'Celkom v {currency}'
          }
        }
      },
      order: {
        newEntity: 'Nová objednávka',
        contact: {
          label: 'Kontakt',
          helperText: '',
          helperTextPreview: ''
        },
        commissionTotal: {
          label: 'Celková provízia',
          helperText: '',
          helperTextPreview: ''
        },
        currency: {
          label: 'Mena',
          helperText: '',
          helperTextPreview: ''
        },
        dateOfOrder: {
          label: 'Dátum objednania',
          helperText: '',
          helperTextPreview: ''
        },
        number: {
          label: 'Číslo',
          helperText: 'Pre automatické vygenerovánie čísla nechajte nevyplnené.',
          helperTextPreview: ''
        },
        offer: {
          label: 'Ponuka',
          helperText: '',
          helperTextPreview: ''
        },
        opportunity: {
          label: 'Dopyt',
          helperText: '',
          helperTextPreview: ''
        },
        owner: {
          label: 'Vlastník',
          helperText: '',
          helperTextPreview: ''
        },
        salesMargin: {
          label: 'Obchodná marža',
          helperText: '',
          helperTextPreview: ''
        },
        subjects: {
          title: 'Predmet',
          discount: {
            label: 'Zľava',
            helperText: '',
            helperTextPreview: ''
          },
          commission: {
            label: 'Provízia',
            helperText: '',
            helperTextPreview: ''
          },
          list: {
            package: 'Veľkosť balenia'
          },
          listPrice: {
            label: 'Cenníková cena',
            helperText: '',
            helperTextPreview: ''
          },
          price: {
            label: 'Predajná cena',
            helperText: '',
            helperTextPreview: ''
          },
          product: {
            label: 'Produkt',
            helperText: '',
            helperTextPreview: ''
          },
          quantity: {
            label: 'Množstvo',
            helperText: '',
            helperTextPreview: ''
          },
          salesMargin: {
            label: 'Obchodná marža',
            helperText: '',
            helperTextPreview: ''
          },
          subjectTotal: {
            label: 'Za položku celkom',
            helperText: '',
            helperTextPreview: ''
          },
          unit: {
            label: 'Jednotka',
            helperText: '',
            helperTextPreview: ''
          }
        },
        total: {
          label: 'Celkom',
          helperText: '',
          helperTextPreview: ''
        },
        numberOfSubjects: '{number, plural, =0 {žiadne položky} one {1 položka} few {{number} položky} other {{number} položiek}}'
      },
      myOrdersScoringBlog: {
        title: 'Moje objednávky'
      },
      ordersList: 'Objednávky'
    }
  }
};
var _default = messages;
exports.default = _default;